import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dialog-table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row no-wrap items-center" }
const _hoisted_4 = { style: {"font-weight":"500","color":"#111","align-self":"flex-start"} }
const _hoisted_5 = {
  key: 0,
  class: "q-ml-xs inline-flex self-start"
}
const _hoisted_6 = { class: "shrink-col" }
const _hoisted_7 = {
  key: 0,
  class: "text-right",
  style: {"font-size":"14px","padding-top":"10px"}
}
const _hoisted_8 = {
  key: 1,
  class: "row no-wrap justify-end"
}
const _hoisted_9 = { class: "shrink-col" }
const _hoisted_10 = {
  key: 0,
  style: {"font-size":"14px","padding-top":"10px"}
}
const _hoisted_11 = { style: {"font-size":"14px","padding-top":"10px"} }
const _hoisted_12 = {
  key: 0,
  style: {"font-size":"14px","padding-top":"10px"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "q-ml-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_position_row = _resolveComponent("position-row")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", { style: {"min-width":"30vw"} }, null, -1)),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('qty_per_unit')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('price_per_unit')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('amount_lower')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('price_calc_method_short')), 1),
          (_ctx.showRemoveBtn)
            ? (_openBlock(), _createElementBlock("th", _hoisted_2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel, (row, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: row.id
          }, [
            _createElementVNode("td", {
              style: {"padding":"10px"},
              class: _normalizeClass([{ 'error-text': _ctx.createType !== 0 && !_ctx.getStorage(row) && row.storagesWithQuantities?.length }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(i+1) + ") ", 1),
                _createVNode(_component_position_row, {
                  id: row.id,
                  el: row.pos_with_vcode,
                  "read-only": _ctx.readOnly
                }, null, 8, ["id", "el", "read-only"]),
                (row.id && _ctx.positionLockStatus(row))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_component_q_tooltip, {
                        delay: 300,
                        anchor: "top middle",
                        self: "center middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.positionLockStatus(row) === 'locked_by_other' ? _ctx.$t('entity_locked_other_user') : _ctx.$t('entity_locked_or_other_reason')), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_icon, {
                        name: "lock",
                        size: "16px",
                        color: "warning"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("td", _hoisted_6, [
              (_ctx.readOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row.qty) + " " + _toDisplayString(row.MeasureUnit?.Name), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_native_input, {
                      ref_for: true,
                      ref: 'qty_input_'+row.id,
                      modelValue: row.qty,
                      "onUpdate:modelValue": [($event: any) => ((row.qty) = $event), ($event: any) => (_ctx.recalcRow(row))],
                      "max-number-value": _ctx.createType !== 0 ? (_ctx.getStorage(row)?.Count || 0) : undefined,
                      "input-type": "number",
                      "edit-on-click": true,
                      disabledField: !_ctx.canEdit || !_ctx.canEditQuantity
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "max-number-value", "disabledField"]),
                    _createVNode(_component_q_select, {
                      flat: "",
                      modelValue: row.MeasureUnit,
                      "onUpdate:modelValue": ($event: any) => ((row.MeasureUnit) = $event),
                      class: "q-mb-xs q-mr-xs thin-input-noborder",
                      "fill-input": "",
                      "bottom-slots": false,
                      dense: "",
                      outlined: "",
                      disable: !_ctx.canEdit || !_ctx.canEditQuantity,
                      "label-slot": false,
                      "hide-bottom-space": "",
                      "dropdown-icon": "expand_more",
                      "option-value": "Id",
                      "option-label": "Name",
                      "input-debounce": "500",
                      "input-class": "text-right",
                      ref_for: true,
                      ref: 'measure_select_' + row.id,
                      options: 
                  _ctx.storage_pos?.measureUnits ? _ctx.storage_pos?.measureUnits.Hints : []
                
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disable", "options"])
                  ]))
            ]),
            _createElementVNode("td", _hoisted_9, [
              (_ctx.readOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.money(row.price)), 1))
                : (_openBlock(), _createBlock(_component_native_input, {
                    key: 1,
                    ref_for: true,
                    ref: 'price_input_'+row.id,
                    modelValue: row.price,
                    "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                    "input-type": "number",
                    "edit-on-click": true,
                    onBlur: ($event: any) => (_ctx.recalcRow(row)),
                    disabledField: (_ctx.createType !== 0 || row.PriceType.Id !== 2) || !_ctx.canEdit
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "disabledField"]))
            ]),
            _createElementVNode("td", _hoisted_11, _toDisplayString(row.amount), 1),
            _createElementVNode("td", null, [
              (_ctx.readOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(row.PriceType?.Name), 1))
                : (_openBlock(), _createBlock(_component_q_select, {
                    key: 1,
                    flat: "",
                    disable: _ctx.createType !== 0 || !_ctx.canEdit,
                    modelValue: row.PriceType,
                    "onUpdate:modelValue": [($event: any) => ((row.PriceType) = $event), ($event: any) => (_ctx.updateRowPrice(row))],
                    class: "q-mb-xs q-mr-xs thin-input-noborder",
                    "fill-input": "",
                    "bottom-slots": false,
                    dense: "",
                    outlined: "",
                    "label-slot": false,
                    "hide-bottom-space": "",
                    "dropdown-icon": "expand_more",
                    "option-value": "Id",
                    "option-label": "Name",
                    "input-debounce": "500",
                    ref_for: true,
                    ref: 'price_select_' + row.id,
                    options: _ctx.priceOptions
                  }, null, 8, ["disable", "modelValue", "onUpdate:modelValue", "options"]))
            ]),
            (_ctx.showRemoveBtn)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                  _createElementVNode("span", {
                    class: "table-remove",
                    title: _ctx.$t('remove')
                  }, [
                    _createVNode(_component_app_icon, {
                      name: "close",
                      width: "16px",
                      color: "#979797",
                      "hover-color": "#616161",
                      cursor: "pointer"
                    }),
                    _createVNode(_component_q_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_card_section, { class: "row items-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_app_icon, {
                                  name: "delete-outline",
                                  width: "18px",
                                  color: "#979797"
                                }),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("sure_delete")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_card_actions, { align: "right" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_q_btn, {
                                  size: "sm",
                                  flat: "",
                                  label: _ctx.$t('cancel'),
                                  color: "dark"
                                }, null, 8, ["label"]), [
                                  [_directive_close_popup]
                                ]),
                                _withDirectives(_createVNode(_component_q_btn, {
                                  size: "sm",
                                  flat: "",
                                  label: _ctx.$t('remove'),
                                  autofocus: "",
                                  color: "dark",
                                  onClick: ($event: any) => (_ctx.remove(row.id))
                                }, null, 8, ["label", "onClick"]), [
                                  [_directive_close_popup]
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ], 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}